module.exports = __webpack_public_path__ + "static/comic-892a2bd9ce0c9c293a620679d1067910.png";